import { Button } from '@/components/ui/button';
import { Play, ArrowRight } from 'lucide-react';
import { APP_CONFIG } from '@/lib/constants';
import { cn } from '@/lib/utils';
import type { HeroProps } from '@/types';
import { useNavigate } from 'react-router-dom';

/**
 * Hero Section Component
 * Main landing section with headline, description, and CTA buttons
 */
export function Hero({ className }: HeroProps) {
  const navigate = useNavigate()
  const handleGetStartedClick=()=>{
   
    console.log('Get Started button clicked - navigating to /signup');
navigate('/signup')
    // Use window.location for more reliable navigation
    
  }

  return (
    <section className={cn(
      "relative py-8 lg:py-20 overflow-hidden",
      className
    )}>
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-hero opacity-10"></div>
      
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Content */}
          <div className="space-y-8 animate-fade-in">
            <div className="space-y-4">
              <h1 className="text-3xl lg:text-5xl font-bold leading-tight">
                <span className="gradient-primary bg-clip-text text-transparent">
                  {APP_CONFIG.tagline.split(' ').slice(0, 2).join(' ')}
                </span>{" "}
                <span className="text-white">
                  {APP_CONFIG.tagline.split(' ')[2]}
                </span>{" "}
                <span className="gradient-primary bg-clip-text text-transparent">
                  {APP_CONFIG.tagline.split(' ').slice(3).join(' ')}
                </span>
              </h1>
              <p
                className="text-2xl font-bold py-3 text-muted-foreground max-w-2xl"
                dangerouslySetInnerHTML={{ __html: APP_CONFIG.subHeader }}
              />
              <p
                className="text-lg text-muted-foreground max-w-xl"
                dangerouslySetInnerHTML={{ __html: APP_CONFIG.description }}
              />
            </div>
            
            {/* Call-to-Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-primary hover:bg-primary/90 shadow-glow animate-glow z-50"
                onClick={handleGetStartedClick}
               
              >
                <Play className="w-5 h-5 mr-2" />
                Get Started
              </Button>
             
              <Button 
                size="lg" 
                variant="outline" 
                className="border-primary/20 hover:bg-primary/10"
              >
                <ArrowRight className="w-5 h-5 mr-2" />
                See in Action
              </Button>
            </div>
          </div>
          
          {/* Hero Image */}
          <div className="relative animate-scale-in">
            <div className="absolute inset-0 bg-gradient-primary blur-3xl opacity-20 rounded-full"></div>
            <img 
              src="/images/hero-ai-brain.jpg" 
              alt="AI Infrastructure Management" 
              className="relative rounded-2xl shadow-elegant w-full"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
